<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/skytraxx.png">
    <WindWidgetFramework :windstations="windstations" :needLoad="needLoadWs"/>
  </div>
</template>

<script>

import WindWidgetFramework from './components/WindWidgetFramework.vue'

export default {
  name: 'app',
  components: {
    WindWidgetFramework
  },

  data()
  {
    return {
      windstations: [],
      needLoadWs: true,
      needLoad: true,
    }
  },

  mounted: function()
  {
    fetch('https://fnb.skytraxx.org/fanetdb/windstation/overview', { methode : 'get' })
    .then((response) => { return response.json() })
    .then((jsonData) =>
    { 
      /* remove any content w/o attached service */
      //note: iterate backwards over list, as after slice indexies are rebuild...
      for(var i = jsonData.length -1; i >= 0 ; i--)
      {
        if(Object.keys(jsonData[i]).includes('has_wind') == false && Object.keys(jsonData[i]).includes('has_temp') == false)
          jsonData.splice(i, 1);
      }

      this.windstations = jsonData;
      this.needLoadWs = false;
    });
  },

  methods:
  {

  },

  watch: 
  {

  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
